<bdeo-drawer
  #drawer
  [closable]="!loading"
  overlay
  [headerTitle]="
    (this.damage ? 'brokers:add_damages.edit_damage_drawer_title' : 'brokers:add_damages.add_damage_drawer_title') | i18nextEager
  "
>
  <form [formGroup]="damageForm" (ngSubmit)="save()">
    <div class="add-wrapper">
      <bdeo-select
        [error]="saveButtonClicked && !part.valid"
        [required]="isRequired(part)"
        [searchInput]="true"
        size="medium"
        type="form"
        label="{{ 'brokers:add_damages.add_damage_drawer_part_label' | i18nextEager }}"
        placeholder="{{ 'brokers:add_damages.add_damage_drawer_part_placeholder' | i18nextEager }}"
        [addNew]="true"
        [options]="partSelectOptions"
        formControlName="part"
        ngDefaultControl
      >
        <span *ngIf="saveButtonClicked && !part.valid" slot="help-text">
          {{ 'brokers:add_damages.add_damage_drawer_part_help' | i18nextEager }}
        </span>
      </bdeo-select>
      <div class="form-group">
        <bdeo-select
          [error]="saveButtonClicked && !typology.valid"
          [required]="isRequired(typology)"
          formControlName="typology"
          size="medium"
          type="form"
          label="{{ 'brokers:add_damages.add_damage_drawer_type_label' | i18nextEager }}"
          placeholder="{{ 'brokers:add_damages.add_damage_drawer_type_placeholder' | i18nextEager }}"
          [options]="typologiesSelectOptions"
          value=""
          ngDefaultControl
        >
          <span *ngIf="saveButtonClicked && !typology.valid" slot="help-text">
            {{ 'brokers:add_damages.add_damage_drawer_typology_help' | i18nextEager }}
          </span>
        </bdeo-select>
        <bdeo-select
          [error]="saveButtonClicked && !severity.valid"
          [required]="isRequired(severity)"
          formControlName="severity"
          size="medium"
          type="form"
          label="{{ 'brokers:add_damages.add_damage_drawer_severity_label' | i18nextEager }}"
          placeholder="{{ 'brokers:add_damages.add_damage_drawer_severity_placeholder' | i18nextEager }}"
          [options]="severitiesSelectOptions"
          [sortOptions]="false"
          value=""
          ngDefaultControl
        >
          <span *ngIf="saveButtonClicked && !severity.valid" slot="help-text">
            {{ 'brokers:add_damages.add_damage_drawer_severity_help' | i18nextEager }}
          </span>
        </bdeo-select>
      </div>
      <div class="form-group">
        <div class="input-controls-wrapper">
          <bdeo-input
            [error]="!surface.valid"
            [required]="isRequired(surface)"
            formControlName="surface"
            size="medium"
            type="form"
            variant="number"
            placeholder="0.00"
            label="{{ 'brokers:add_damages.add_damage_drawer_surface_label' | i18nextEager }}"
            value=""
            inputSize="80"
            step="0.1"
            min="0"
            ngDefaultControl
          >
            <span slot="suffix">dm²</span>
            <span *ngIf="!surface.valid && !surface.pristine" slot="help-text">
              {{ 'brokers:add_damages.add_damage_drawer_surface_help' | i18nextEager }}
            </span>
          </bdeo-input>
          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="surface.disabled || (surface.value && surface.value <= 0) || loading"
              (click)="decrement(surface, 0.1)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="surface.disabled || loading"
              (click)="increment(surface, 0.1)"
            ></bdeo-button>
          </span>
        </div>
        <bdeo-select
          [error]="saveButtonClicked && !operation.valid"
          [required]="isRequired(operation)"
          formControlName="operation"
          [options]="operations"
          size="medium"
          type="form"
          label="{{ 'brokers:add_damages.add_damage_drawer_operation_label' | i18nextEager }}"
          placeholder="{{ 'brokers:add_damages.add_damage_drawer_operation_placeholder' | i18nextEager }}"
          value=""
          ngDefaultControl
        >
          <span *ngIf="saveButtonClicked && !operation.valid" slot="help-text">
            {{ 'brokers:add_damages.add_damage_drawer_operation_help' | i18nextEager }}
          </span></bdeo-select
        >
      </div>
      <div class="form-group" *ngIf="operation.value === 'replace'">
        <div class="input-controls-wrapper">
          <bdeo-input
            [error]="!partReference.valid && !partReference.pristine"
            [required]="isRequired(partReference)"
            formControlName="partReference"
            size="medium"
            inputSize="80"
            type="form"
            variant="text"
            placeholder="{{ 'brokers:add_damages.add_damage_drawer_part_id_placeholder' | i18nextEager }}"
            label="{{ 'brokers:add_damages.add_damage_drawer_part_id_label' | i18nextEager }}"
            value=""
            ngDefaultControl
          >
            <span *ngIf="!partReference.valid && !partReference.pristine" slot="help-text">
              {{ 'brokers:add_damages.add_damage_drawer_part_id_help' | i18nextEager }}
            </span>
          </bdeo-input>
        </div>
        <div class="input-controls-wrapper">
          @if (loading) {
            <div class="skeleton-wrapper">
              <div>{{ 'brokers:add_damages.add_damage_drawer_price_label' | i18nextEager }}</div>
              <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
            </div>
          } @else {
            <bdeo-input
              [error]="!price.valid && !price.pristine"
              [required]="isRequired(price)"
              formControlName="price"
              size="medium"
              inputSize="80"
              type="form"
              variant="number"
              placeholder="0.00"
              min="0"
              label="{{ 'brokers:add_damages.add_damage_drawer_price_label' | i18nextEager }}"
              value=""
              ngDefaultControl
            >
              <span slot="suffix">{{ currency }}</span>
              <span *ngIf="!price.valid && !price.pristine" slot="help-text">
                {{ 'brokers:add_damages.add_damage_drawer_price_help' | i18nextEager }}
              </span>
            </bdeo-input>
          }
          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="price.disabled || (price.value && price.value <= 0) || loading"
              (click)="decrement(price)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="price.disabled || loading"
              (click)="increment(price)"
            ></bdeo-button>
          </span>
        </div>
      </div>
      <div class="form-group" *ngIf="operation.valid">
        <div class="input-controls-wrapper">
          @if (loading) {
            <div class="skeleton-wrapper">
              <div>{{ 'brokers:add_damages.add_damage_drawer_paint_hours_label' | i18nextEager }}</div>
              <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
            </div>
          } @else {
            <bdeo-input
              [error]="!paintHours.valid && !paintHours.pristine"
              [required]="isRequired(paintHours)"
              formControlName="paintHours"
              size="medium"
              inputSize="80"
              type="form"
              variant="number"
              placeholder="0.00"
              min="0"
              label="{{ 'brokers:add_damages.add_damage_drawer_paint_hours_label' | i18nextEager }}"
              value=""
              ngDefaultControl
            >
              <span slot="suffix">h</span>
              <span *ngIf="!paintHours.valid && !paintHours.pristine" slot="help-text">
                {{ 'brokers:add_damages.add_damage_drawer_paint_hours_help' | i18nextEager }}
              </span>
            </bdeo-input>
          }

          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="paintHours.disabled || (paintHours.value && paintHours.value <= 0) || loading"
              (click)="decrement(paintHours)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              [disabled]="paintHours.disabled || loading"
              bigIcon
              (click)="increment(paintHours)"
            ></bdeo-button>
          </span>
        </div>
        <div class="input-controls-wrapper">
          @if (loading) {
            <div class="skeleton-wrapper">
              <div>{{ 'brokers:add_damages.add_damage_drawer_paint_materials_label' | i18nextEager }}</div>
              <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
            </div>
          } @else {
            <bdeo-input
              [error]="!paintMaterials.valid && !paintMaterials.pristine"
              [required]="isRequired(paintMaterials)"
              formControlName="paintMaterials"
              size="medium"
              inputSize="80"
              type="form"
              variant="number"
              placeholder="0.00"
              min="0"
              label="{{ 'brokers:add_damages.add_damage_drawer_paint_materials_label' | i18nextEager }}"
              value=""
              ngDefaultControl
            >
              <span slot="suffix">{{ currency }}</span>
              <span *ngIf="!paintMaterials.valid && !paintMaterials.pristine" slot="help-text">
                {{ 'brokers:add_damages.add_damage_drawer_paint_materials_help' | i18nextEager }}
              </span>
            </bdeo-input>
          }

          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="paintMaterials.disabled || (paintMaterials.value && paintMaterials.value <= 0) || loading"
              (click)="decrement(paintMaterials)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="paintMaterials.disabled || loading"
              (click)="increment(paintMaterials)"
            ></bdeo-button>
          </span>
        </div>
      </div>
      <div class="form-group" *ngIf="operation.valid">
        <div class="input-controls-wrapper">
          @if (loading) {
            <div class="skeleton-wrapper">
              <div>{{ 'brokers:add_damages.add_damage_drawer_labour_hours_label' | i18nextEager }}</div>
              <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
            </div>
          } @else {
            <bdeo-input
              [error]="!labourHours.valid && !labourHours.pristine"
              [required]="isRequired(labourHours)"
              formControlName="labourHours"
              size="medium"
              inputSize="80"
              type="form"
              variant="number"
              placeholder="0.00"
              min="0"
              label="{{ 'brokers:add_damages.add_damage_drawer_labour_hours_label' | i18nextEager }}"
              value=""
              ngDefaultControl
            >
              <span slot="suffix">h</span>
              <span *ngIf="!labourHours.valid && !labourHours.pristine" slot="help-text">
                {{ 'brokers:add_damages.add_damage_drawer_labour_hours_help' | i18nextEager }}
              </span>
            </bdeo-input>
          }

          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="labourHours.disabled || (labourHours.value && labourHours.value <= 0) || loading"
              (click)="decrement(labourHours)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="labourHours.disabled || loading"
              (click)="increment(labourHours)"
            ></bdeo-button>
          </span>
        </div>
        <div class="input-controls-wrapper">
          @if (loading) {
            <div class="skeleton-wrapper">
              <div>{{ 'brokers:add_damages.add_damage_drawer_assembly_hours_label' | i18nextEager }}</div>
              <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
            </div>
          } @else {
            <bdeo-input
              [error]="!assemblyHours.valid && !assemblyHours.pristine"
              [required]="isRequired(assemblyHours)"
              formControlName="assemblyHours"
              size="medium"
              inputSize="80"
              type="form"
              variant="number"
              min="0"
              placeholder="0.00"
              label="{{ 'brokers:add_damages.add_damage_drawer_assembly_hours_label' | i18nextEager }}"
              value=""
              ngDefaultControl
            >
              <span slot="suffix">h</span>
              <span *ngIf="!assemblyHours.valid && !assemblyHours.pristine" slot="help-text">
                {{ 'brokers:add_damages.add_damage_drawer_assembly_hours_help' | i18nextEager }}
              </span>
            </bdeo-input>
          }

          <span class="mobile-controls">
            <bdeo-button
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="assemblyHours.disabled || (assemblyHours.value && assemblyHours.value <= 0) || loading"
              (click)="decrement(assemblyHours)"
            ></bdeo-button>
            <bdeo-button
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="assemblyHours.disabled || loading"
              (click)="increment(assemblyHours)"
            ></bdeo-button>
          </span>
        </div>
      </div>
    </div>
  </form>

  @if (images.length > 0) {
    <div class="images-container">
      @for (image of images.controls; track image; let index = $index) {
        <div class="image-item" [ngClass]="{ 'image-item--error': !image.valid }">
          <div class="image-item__image">
            <img
              [src]="image.value.fileUrl"
              alt="image"
              loading="lazy"
              placeholder="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            />
            <span>{{ image.value.file.name }}</span>
          </div>
          <bdeo-icon class="image-item__delete-icon" name="action-delete" (click)="removeImage(index)"></bdeo-icon>
        </div>

        @if (image.errors?.['maxSize']) {
          <div class="image-item__error-label">{{ 'brokers:add_damages.add_damage_drawer_image_error_size' | i18nextEager }}</div>
        } @else if (image.errors?.['mimetype']) {
          <div class="image-item__error-label">{{ 'brokers:add_damages.add_damage_drawer_image_error_mimetype' | i18nextEager }}</div>
        }
      }
    </div>
  }

  <div class="add-image-button-wrapper">
    <input #addImageInput type="file" accept="capture=camera;image/*" (change)="addImage($event)" hidden />
    <bdeo-button
      type="secondary"
      skin="ghost"
      icon="media-image"
      [text]="'brokers:add_damages.add_damage_drawer_add_image_button' | i18nextEager"
      (click)="openCaptureImageDialog()"
      [disabled]="!part.valid || loading"
      [attr.data-test-id]="'damage-drawer-add-image-button'"
    ></bdeo-button>
  </div>

  <app-footer selectorForPadding=".add-image-button-wrapper">
    <bdeo-button
      type="primary"
      [icon]="'check-check'"
      [text]="'brokers:add_damages.add_damage_drawer_save_button' | i18nextEager"
      [disabled]="!damageForm.valid || damageForm.pristine || loading"
      (click)="save()"
      [attr.data-test-id]="'damage-drawer-save-damage'"
    ></bdeo-button>
    <bdeo-button
      type="secondary"
      [text]="'brokers:add_damages.add_damage_drawer_cancel_button' | i18nextEager"
      skin="ghost"
      [disabled]="loading"
      (click)="close()"
      [attr.data-test-id]="'damage-drawer-cancel-damage'"
    ></bdeo-button>
  </app-footer>
</bdeo-drawer>
